/* eslint no-console: off */

/*import '@polymer/gold-cc-expiration-input/gold-cc-expiration-input.js';

(function () {
    // This is a hack to add functionality to allow tabbing into the gold-cc-expiration-input element.

    let ELE = customElements.get('gold-cc-expiration-input');
    if (ELE && ELE.prototype) ELE = ELE.prototype;
    else {
        console.log('GoldCcExpirationInput Hack Failed');
        return;
    }

    // Change tabIndex value from -1 to 0 (allowing tabbing).
    ELE.hostAttributes.tabindex = 0;

    // Add handler on focus will actually focus the first input (month expiration date).
    ELE.listeners['focus'] = '_handleReFocus';

    ELE._handleReFocus = function () {
        this.inputElement.$.expirationMonth.inputElement.focus();
    };
})();*/